function throwError(e) { throw e; }
exports.throwError = throwError;
//# sourceMappingURL=throwError.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/util/throwError.js
 ** module id = 246
 ** module chunks = 0
 **/